import MenuList from '@mui/material/MenuList';
import React, { Fragment } from 'react';

class EducatorProfileList extends React.Component {

  render() {
    //const { profiles } = this.props;

    return(
      <Fragment>
        <MenuList disablePadding>
          {this.props.getProfileList()}
        </MenuList>
      </Fragment>
    );
  }

}

export default EducatorProfileList;
